/**
 * @generated SignedSource<<68c9043616d9f25bf1b0576ff20d786f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PaediaMultipleChoiceElementPart_SubmittedAnswersQuery$variables = {
  submissionId: string;
};
export type PaediaMultipleChoiceElementPart_SubmittedAnswersQuery$data = {
  readonly LearnV2: {
    readonly GetSubmittedAnswers: ReadonlyArray<{
      readonly answers: ReadonlyArray<string>;
      readonly question: string;
    }>;
  };
};
export type PaediaMultipleChoiceElementPart_SubmittedAnswersQuery = {
  response: PaediaMultipleChoiceElementPart_SubmittedAnswersQuery$data;
  variables: PaediaMultipleChoiceElementPart_SubmittedAnswersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Queries",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "submissionId",
            "variableName": "submissionId"
          }
        ],
        "concreteType": "MultipleChoiceDecision",
        "kind": "LinkedField",
        "name": "GetSubmittedAnswers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "question",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answers",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaediaMultipleChoiceElementPart_SubmittedAnswersQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PaediaMultipleChoiceElementPart_SubmittedAnswersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "744a2e766b2d5a2a931f0d2ed7bcbd5a",
    "id": null,
    "metadata": {},
    "name": "PaediaMultipleChoiceElementPart_SubmittedAnswersQuery",
    "operationKind": "query",
    "text": "query PaediaMultipleChoiceElementPart_SubmittedAnswersQuery(\n  $submissionId: ID!\n) {\n  LearnV2 {\n    GetSubmittedAnswers(submissionId: $submissionId) {\n      question\n      answers\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "79ca985787671323fae0fa46ea82e291";

export default node;
